import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import ProcessUtils from 'utils/ProcessUtils';
import InfoIcon from 'components/core/InfoIcon';
import RIEToggle from 'components/core/editable/RIEToggle';
import InfoMessages from 'components/core/help/InfoMessages';


export default class AdvancedTransformationQuestion extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        type: PropTypes.string, //'inputQC' or 'outputQC'
        dimensionName: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.typeInputQC = 'inputQC';
        this.typeOutputQC = 'outputQC';
        this.boldFont = css`font-weight:900;`;
    }

    getValue = () => {
        let value = null;
        if (this.props.type === this.typeInputQC) {
            value = ProcessUtils.shouldShowWizardInputQC(this.props.process, ['missing_value', 'qc_mask', 'qc_bad']);
        } else if (this.props.type === this.typeOutputQC) {
            value = ProcessUtils.shouldShowWizardOutputQC(this.props.process, ['std_ind_max', 'std_bad_max', 'goodfrac_ind_min', 'goodfrac_bad_min'], this.props.dimensionName);
        }

        return value;
    };

    getQuestion = () => {
        let question = '';
        if (this.props.type === this.typeInputQC) {
            question = 'Would you like to change the default values for missing missing_value attributes or which indeterminate QC should be marked as bad?';
        } else if (this.props.type === this.typeOutputQC) {
            question = 'Would you like to set a QC threshold for standard deviation or the fraction of \'good\' values?';
        }

        return question;
    };

    getInfoMessage = () => {
        let infoMessage = null;
        if (this.props.type === this.typeInputQC) {
            infoMessage = InfoMessages.advancedSettings;
        } else if (this.props.type === this.typeOutputQC) {
            infoMessage = InfoMessages.outputQC;
        }

        return infoMessage;
    };

    onToggleInputQCDisplay = () => {
        const parameters = ['missing_value', 'qc_mask', 'qc_bad'];
        const currentValue = ProcessUtils.shouldShowWizardInputQC(this.props.process, parameters);
        if (currentValue) {
            const editor = ProcessUtils.getEditor(this.props.process);
            editor.removeTransformationParameterOverride(parameters, ProcessUtils.getWizardCoordinateSystemName(this.props.process));
            editor.commit();
        }

        // toggle the showAdvanced in processUIState
        const showWizardInputQC = !currentValue;

        ProcessUtils.updateProcessUIState(this.props.process.name, { showWizardInputQC });
    };

    onToggleOutputQCDisplay = () => {
        const parameters = ['std_ind_max', 'std_bad_max', 'goodfrac_ind_min', 'goodfrac_bad_min'];
        const dimensionName = this.props.dimensionName;

        const currentValue = ProcessUtils.shouldShowWizardOutputQC(this.props.process, parameters, dimensionName);
        if (currentValue) {
            const editor = ProcessUtils.getEditor(this.props.process);
            editor.removeTransformationParameterOverride(parameters, ProcessUtils.getWizardCoordinateSystemName(this.props.process), dimensionName);
            editor.commit();
        }

        // toggle the showAdvanced in processUIState
        const showWizardOutputQC = !currentValue;

        ProcessUtils.updateProcessUIState(this.props.process.name, { showWizardOutputQC });
    };

    onAdvancedSettingsChange = () => {
        if (this.props.type === this.typeInputQC) {
            this.onToggleInputQCDisplay();
        } else if (this.props.type === this.typeOutputQC) {
            this.onToggleOutputQCDisplay();
        }
    };

    render = () => {
        return (
            <Flexbox flexDirection={'row'} className={css`margin-bottom:10px`} alignItems="flex-start">
                <Flexbox flexDirection={'row'} alignItems="center">
                    <InfoIcon message={this.getInfoMessage()} />
                    <div className={this.boldFont}>{this.getQuestion()}</div>
                </Flexbox>

                <Flexbox margin="-1px 0 0 5px">
                    <RIEToggle
                        value={this.getValue()}
                        textFalse="No"
                        textTrue="Yes"
                        change={this.onAdvancedSettingsChange}
                        fieldPath={[]}
                        radioGroupName="advancedSettingsValue"
                        formDisplay
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                    />
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/AdvancedTransformationQuestion.js